import type * as React from "react";

interface IProps {
    value: string;
    onChange: (value: string) => void;
}

function SearchFilter({ value, onChange }: IProps) {
    const onChangeInput = (event: React.FormEvent<HTMLInputElement>) => {
        onChange(event.currentTarget.value);
    };
    return (
        <label>
            Content:
            <input type="text" value={value} onChange={onChangeInput} />
        </label>
    );
}

export default SearchFilter;
